import React, { useState } from 'react'
import { Box, Button, IconButton, Stack, Typography } from '@mui/material'
import { type CardComponentProps } from 'nextstepjs'
import Image from 'next/image'

import { TourConfirmSkipModal } from './tour-confirm-skip-modal'
import styles from './tour-card.module.scss'

const TOUR_SUGGESTED_QUERY_EVENT = 'tour-suggested-query'

export const TourCard: React.FC<CardComponentProps> = ({
	step,
	currentStep,
	totalSteps,
	nextStep,
	skipTour,
	arrow,
}) => {
	const extendedStep = step as typeof step & {
		suggestedQuery?: string
		nextButtonText?: string
		sendMessageOnClick?: boolean
	}

	const [confirmSkipOpen, setConfirmSkipOpen] = useState(false)

	const handleSkipClick = () => {
		setConfirmSkipOpen(true)
	}

	const handleConfirmSkip = () => {
		setConfirmSkipOpen(false)
		skipTour?.()
	}

	const handleNextClick = () => {
		if (extendedStep.suggestedQuery && typeof window !== 'undefined') {
			window.dispatchEvent(
				new CustomEvent(TOUR_SUGGESTED_QUERY_EVENT, { detail: { query: extendedStep.suggestedQuery } })
			)
		}
		if (extendedStep.sendMessageOnClick && typeof window !== 'undefined') {
			window.dispatchEvent(new CustomEvent('tour-send-message'))
		}
		nextStep()
	}
	return (
		<Box className={styles.tourCard}>
			{step.showSkip && skipTour && (
				<IconButton
					className={styles.closeButton}
					onClick={handleSkipClick}
					size="small"
				>
					<Image src="/x-mark.svg" width={14} height={14} alt="Закрыть" />
				</IconButton>
			)}

			<Box className={styles.content}>
				{step.icon && (
					<Box className={styles.iconContainer}>
						<Typography variant="h4" className={styles.iconText}>
							{step.icon}
						</Typography>
					</Box>
				)}

				{step.title && (
					<Typography variant="h5" className={styles.title}>
						{step.title}
					</Typography>
				)}

				{step.content && (
					<Typography className={styles.contentText}>
						{step.content}
					</Typography>
				)}

				{step.showControls && (
					<Stack direction="row" spacing={2} className={styles.controls}>
						{skipTour && (
							<Button
								variant="outlined"
								onClick={handleSkipClick}
								className={`${styles.button} ${styles.buttonBack}`}
							>
								Пропустить обучение
							</Button>
						)}

						<Button
							variant="contained"
							onClick={handleNextClick}
							className={`${styles.button} ${styles.buttonNext}`}
						>
							{extendedStep.nextButtonText ??
								(currentStep < totalSteps - 1 ? 'Далее' : 'Завершить')}
						</Button>
					</Stack>
				)}
			</Box>
			<TourConfirmSkipModal
				open={confirmSkipOpen}
				onConfirm={handleConfirmSkip}
				onClose={() => setConfirmSkipOpen(false)}
			/>
		</Box>
	)
}

